declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

function track(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
}

// ── Landing page ──

const landingCtaClicked = (location: string) =>
  track('landing_cta_clicked', { location });

const landingVideoClicked = () =>
  track('landing_video_clicked');

const landingWhatsappClicked = (location: string) =>
  track('landing_whatsapp_clicked', { location });

const landingPlanClicked = (planName: string, planId: string) =>
  track('landing_plan_clicked', { plan: planName, plan_id: planId });

const landingLoginClicked = (location: string) =>
  track('landing_login_clicked', { location });

// ── Login / Register page ──

const loginPageViewed = () =>
  track('login_page_viewed');

const loginFormOpened = () =>
  track('login_form_opened');

const registerFormOpened = () =>
  track('register_form_opened');

const registerFieldFocused = (field: string) =>
  track('register_field_focused', { field });

const registerTermsAccepted = () =>
  track('register_terms_accepted');

const registerSubmitted = () =>
  track('register_submitted');

const registerCompleted = () =>
  track('register_completed');

const loginSubmitted = () =>
  track('login_submitted');

const loginCompleted = () =>
  track('login_completed');

// ── Onboarding ──

const onboardingViewed = () =>
  track('onboarding_viewed');

const onboardingSlideViewed = (slideIndex: number, slideTitle: string) =>
  track('onboarding_slide_viewed', { slide_index: slideIndex, slide_title: slideTitle });

const onboardingCompleted = () =>
  track('onboarding_completed');

const onboardingSkipped = (atSlide: number) =>
  track('onboarding_skipped', { at_slide: atSlide });

// ── App navigation ──

const conversationModeSelected = (mode: string) =>
  track('conversation_mode_selected', { mode });

const pageViewed = (page: string) =>
  track('page_viewed', { page });

const ataricLandClicked = () =>
  track('ataric_land_clicked');

// ── Chat ──

const chatStarted = (mode: string) =>
  track('chat_started', { mode });


// ── Journey ──

const journeyCourseOpened = () =>
  track('journey_course_opened');

const journeyLessonWatched = (title: string) =>
  track('journey_lesson_watched', { title });

const journeyLessonCompleted = (title: string) =>
  track('journey_lesson_completed', { title });

// ── Pronouncer ──

const pronouncerUsed = () =>
  track('pronouncer_used');

// ── Progress ──

const progressViewed = (state: string) =>
  track('progress_viewed', { state });

const progressShareClicked = () =>
  track('progress_share_clicked');

// ── Plan ──

const planPageViewed = (currentPlan: string) =>
  track('plan_page_viewed', { current_plan: currentPlan });

const analytics = {
  track,
  landingCtaClicked,
  landingVideoClicked,
  landingWhatsappClicked,
  landingPlanClicked,
  landingLoginClicked,
  loginPageViewed,
  loginFormOpened,
  registerFormOpened,
  registerFieldFocused,
  registerTermsAccepted,
  registerSubmitted,
  registerCompleted,
  loginSubmitted,
  loginCompleted,
  onboardingViewed,
  onboardingSlideViewed,
  onboardingCompleted,
  onboardingSkipped,
  conversationModeSelected,
  pageViewed,
  ataricLandClicked,
  chatStarted,
  journeyCourseOpened,
  journeyLessonWatched,
  journeyLessonCompleted,
  pronouncerUsed,
  progressViewed,
  progressShareClicked,
  planPageViewed,
};

export default analytics;
